import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <>
      <div className="bg-lime-800">
        <div className="footer sm:footer-horizontal text-white p-8 py-10 max-w-screen-2xl mx-auto flex flex-col md:flex-row md:justify-between items-center">
          <aside className="md:w-1/2">
            <Link
              to="/"
              className="flex mb-4 items-center space-x-4 text-2xl font-bold"
            >
              <img
                src="/jotrWhite.svg"
                alt="JOTR Logo"
                className="w-28 max-h-auto"
              />
            </Link>
            <div>
              <p className="text-lg font-black">
                JAKARTA OPEN TRAIL RUN (JOTR)
              </p>
              <p className="lg:max-w-3xl">
             Jakarta Open Trail Run (JOTR) Cianjur Series 2026 is the official host of the Southeast Asian Trail Running Cup.
              </p>
              <p className="lg:max-w-2xl">
        This landmark championship brings together elite trail runners from across Southeast Asia to compete on the stunning and demanding terrain of Mount Gede Pangrango National Park, Indonesia.
              </p>
            </div>
          </aside>

          <div className="flex flex-row flex-wrap gap-4 py-10 md:py-0 md:flex items-center space-x-4">
            <img
              src="/icons/utmb3.png"
              alt="UTMB Logo"
              className="w-20 md:w-28 max-h-auto"
            />
            <img
              src="/icons/league.png"
              alt="League Logo"
              className="w-36 md:w-52 max-h-auto"
            />
          </div>
        </div>
      </div>

      <footer className="footer sm:footer-horizontal footer-center bg-white text-base-content p-4">
        <aside>
          <p>
            Copyright © 2026 - All rights reserved PT. Cakrawala Jakarta Kreatif
          </p>
        </aside>
      </footer>
    </>
  );
};
